module.exports = __webpack_public_path__ + "media/images/care_plan_template-c588514e.svg";